// Step 18 — Actions route wrapper.
//
// Reuses the existing DealActionsPanel (Step 13) verbatim.

import DealActionsPanel from "../DealActionsPanel";
import {
  AIEmpty,
  AILoading,
  AIPageHeader,
  AISection,
} from "../shell/AIPrimitives";
import { useAIWorkspace } from "../shell/AIWorkspaceContext";

export default function AIActionsPage() {
  const { loading, activeWorkspace, activeWorkspaceId } = useAIWorkspace();
  if (loading) return <AILoading />;
  if (!activeWorkspaceId) {
    return (
      <>
        <AIPageHeader title="Åtgärder" />
        <AIEmpty title="Ingen affär vald" />
      </>
    );
  }
  return (
    <>
      <AIPageHeader
        title="Åtgärder"
        subtitle={activeWorkspace?.organisation_name}
      />
      <AISection>
        <DealActionsPanel workspaceId={activeWorkspaceId} />
      </AISection>
    </>
  );
}
